import { useNavigate, useLocation } from "react-router-dom";
import UserMenu from "./UserMenu/UserMenu";
import navHeader from "../assets/navHeader.svg";
import { useLogin } from "../context/LoginProvider";
import { useState, useEffect } from "react";
import "./Navbar.css";

export default function Navbar({ isHomePage }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn } = useLogin();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const isCurrentPage = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <img
          src={navHeader}
          onClick={() => handleNavigation("/")}
          alt="Soulmegle"
        />
      </div>

      <button className="hamburger-menu" onClick={toggleMenu}>
        <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
        <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
        <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
      </button>

      <div className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
        {isLoggedIn ? (
          <>
            {!isCurrentPage('/') && (
              <button
                className="nav-button"
                onClick={() => handleNavigation("/")}
              >
                <svg viewBox="0 0 24 24">
                  <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                </svg>
                Home
              </button>
            )}
            {!isCurrentPage('/profile') && (
              <button
                className="nav-button"
                onClick={() => handleNavigation("/profile")}
              >
                <svg viewBox="0 0 24 24">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
                Profile
              </button>
            )}
            {!isCurrentPage('/feedback') && (
              <button
                className="nav-button"
                onClick={() => handleNavigation("/feedback")}
              >
                <svg viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>
                Feedback
              </button>
            )}
          </>
        ) : (
          <>
            {!isCurrentPage('/') && (
              <button
                className="nav-button"
                onClick={() => handleNavigation("/")}
              >
                <svg viewBox="0 0 24 24">
                  <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                </svg>
                Home
              </button>
            )}
            {isCurrentPage('/login') && !isCurrentPage('/signup') && (
              <button
                className="nav-button"
                onClick={() => handleNavigation("/signup")}
              >
                <svg viewBox="0 0 24 24">
                  <path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
                Register
              </button>
            )}
            {isCurrentPage('/signup') && !isCurrentPage('/login') && (
              <button
                className="nav-button"
                onClick={() => handleNavigation("/login")}
              >
                <svg viewBox="0 0 24 24">
                  <path d="M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z" />
                </svg>
                Login
              </button>
            )}
          </>
        )}
        <UserMenu isHomePage={isHomePage} />
      </div>
    </nav>
  );
}